import {inject, injectable} from "inversify";
import {applyPolyfills, defineCustomElements as jeepSqlite} from 'jeep-sqlite/loader';
import {CapacitorSQLite} from '@capacitor-community/sqlite';
import {Capacitor} from '@capacitor/core';
import {sqliteConnection} from "./db";
import {EventEmitter} from "@/modules/base/events";
import BeforeDatabasePreparedEvent from "@/modules/database/events/BeforeDatabasePreparedEvent";
import AfterDatabasePreparedEvent from "@/modules/database/events/AfterDatabasePreparedEvent";

@injectable()
export default class Initializer {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
  ) {
  }

  public init() {
    applyPolyfills().then(() => jeepSqlite(window));

    window.addEventListener('DOMContentLoaded', async () => {
      const platform = Capacitor.getPlatform();

      if (platform === 'web') {
        const jeepEl = document.querySelector('jeep-sqlite');
        if (jeepEl != null) {
          document.body.removeChild(jeepEl);
        }
        // Create the 'jeep-sqlite' Stencil component
        const jeepSqlite = document.createElement('jeep-sqlite');
        document.body.appendChild(jeepSqlite);
        await customElements.whenDefined('jeep-sqlite');
        // Initialize the Web store
        await sqliteConnection.initWebStore();
      }
      // when using Capacitor, you might want to close existing connections,
      // otherwise new connections will fail when using dev-live-reload
      // see https://github.com/capacitor-community/sqlite/issues/106
      CapacitorSQLite.checkConnectionsConsistency({
        dbNames: [], // i.e. "i expect no connections to be open"
      }).catch((e) => {
        // the plugin throws an error when closing connections. we can ignore
        // that since it is expected behaviour
        console.log(e);
        return {};
      });

      await this.em.emitAsync(new BeforeDatabasePreparedEvent());
      await this.em.emitAsync(new AfterDatabasePreparedEvent());
    });
  }
}
